import React from 'react'
import classNames from 'classnames'
import { node, oneOf, string } from 'prop-types'

import styles from './Surround.module.scss'

const Surround = ({
  children,
  padded,
  bordered,
  borderWidth,
  borderColor = 'grey',
  className
}) => (
  <div
    className={classNames(
      styles.Surround,
      padded && styles[`padded-${padded}`],
      bordered && styles[`bordered-${bordered}`],
      borderWidth && styles[`border-width--${borderWidth}`],
      borderColor && styles[`border-color--${borderColor}`],
      className
    )}
  >
    {children}
  </div>
)

Surround.propTypes = {
  children: node,
  padded: string,
  bordered: string,
  borderWidth: oneOf(['thin', 'medium', 'thick']),
  borderColor: oneOf(['darkGrey', 'grey', 'lightGrey']),
  className: string
}

export default Surround
